import { Either } from 'monet';

/**
 * @description Шлюз интеграции мессенджеров.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function MessengersIntegrationGateway(axios) {
  /**
   * @description Получить список мессенджеров.
   * @returns {Promise<Either>}
   */
  this.getMessengersList = () => axios
    .get('/api/integrations/messengers')
    .then(
      (response) => Either.right({
        messengers: response.data.messengers,
      }),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
  /**
   * @description Получить ссылку на Iframe-авторизации.
   * @param {string} messenger
   * @returns {Promise<Either>}
   */
  this.getIframeLink = (messenger) => axios
    .post('/api/integration/messenger/auth-link', { messenger })
    .then(
      (response) => Either.right({
        link: response.data.link,
      }),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
  /**
   * @description Получить ссылку на Iframe веб-мессенджера.
   * @returns {Promise<Either>}
   */
  this.getWebMessengerLink = () => axios
    .get('/api/messengers/link')
    .then(
      (response) => Either.right({
        link: response.data.link,
      }),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
  /**
   * @description Получить токен для авторизации в MAX.
   * @returns {Promise<Either>}
   */
  this.getMaxAuthToken = () => axios
    .get('/api/integration/messenger/max/token')
    .then(
      (response) => Either.right(response.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );

  /**
   * @description Обновить статус авторизации MAX.
   * @param {number} code 0 - не авторизован, 2 - авторизован
   * @returns {Promise<Either>}
   */
  this.updateMaxAuthStatus = (code) => axios
    .post('/api/integration/messenger/max/status', { code })
    .then(
      (response) => Either.right(response),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      },
    );
}
